/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LevelType } from '../../models/level-type';
import { MembershipResponse } from '../../models/membership-response';

export interface GetMemberships$Params {
  levelType?: LevelType;
}

export function getMemberships(http: HttpClient, rootUrl: string, params?: GetMemberships$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MembershipResponse>>> {
  const rb = new RequestBuilder(rootUrl, getMemberships.PATH, 'get');
  if (params) {
    rb.query('levelType', params.levelType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MembershipResponse>>;
    })
  );
}

getMemberships.PATH = '/api/memberships';
